import React, { useState, useEffect } from 'react';
import '../../css/settings.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import CustomButton from '../../components/CustomButton';
import Heading from '../../components/Heading';
import CustomBreadcrumbsSettings from '../../components/Breadcrumbs/CustomBreadcrumbsSettings';
import ImgSettingsNotifySvg from '../../assets/svg/iconSettingsNotify.svg';
import ImgSettingsAddCardSvg from '../../assets/svg/iconSettingsAddCard.svg';
import { FaArrowRightLong } from "react-icons/fa6";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { MdOutlineMail } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { setStatusCarteira } from '../../features/onboardingData/onboardingUserData';
import SuspendedWalletAlert from '../../components/SuspendedWalletAlert';

function Settings() {

    const navigate = useNavigate();
    const location = useLocation();

    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();

    const hadleBtnClickNotifications = () => {
        navigate('/configuracoes/notificacoes');
    };

    const hadleBtnClickAddCard = () => {
        navigate('/configuracoes/associar-cartao');
    };

    const hadleBtnClickDeleteWallet = () => {
        navigate('/configuracoes/desligar-carteira');
    };

    const handleSaudeEmailClick = () => {
        const emailAddress = 'geral@saude360.medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const handleMarketPlaceEmailClick = () => {
        const emailAddress = 'marketplace@medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const handleActiveEmailClick = () => {
        const emailAddress = 'active@medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const handleBtnGoToContacts = () => {
        const element = document.getElementById('contactMainContainer');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        if (location.hash) {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        }
    }, [location]);

    const handleBtnCall = () => {
        const phoneNumber = '218458888';
        window.location.href = `tel:${phoneNumber}`;
    };
    
    return (  
        <>
        <Header/> 
        <div className={ isTablet ? "mainViewContainerSettings" : ( isMobile ? 'mainViewContainerSettingsTablet' : 'mainViewContainerSettingsMobile') }>
            <div className={ isTablet ? 'firstTxtViewContainerSettings' : ( isMobile ? 'firstTxtViewContainerSettingsTablet' : 'firstTxtViewContainerSettingsMobile') }>
                <div style={ isTablet ? { width: '100%', height: '100%', marginBottom: '48px', marginTop: '-48px' } :  ( isMobile ? { width: '100%', height: '100%', paddingInline: '40px', paddingTop: '-48px' } : { width: '100%', height: '100%', paddingInline: '16px' })}>
                    { (isStatusCarteira ===  '2')  &&
                        <SuspendedWalletAlert onPress={handleBtnGoToContacts} />
                    }
                </div>
                <div className='mainHeadingViewContainerSettings'> 
                    <CustomBreadcrumbsSettings hasPadding hasSettings />
                    <Heading hasPadding hasBtnBack={false}/>
                </div>
                <div className={ isTablet ? 'secondMainContainerSettings' : ( isMobile ? 'secondMainContainerSettingsTablet' : 'secondMainContainerSettingsMobile') }>
                    <div className={ isTablet ? 'firstSubMainContainerSettings' : 'firstSubMainContainerSettingsMobile' }>
                        <div className='secondTitleViewSettings'>
                            <div className={ isTablet ? 'textTitleRegular400Settings' : ( isMobile ? 'textTitleRegular400SettingsTablet' : 'textTitleRegular400SettingsMobile') }>Configurações da carteira</div>
                        </div>
                        <div className='txtSecondTitleViewSettings'>
                            <div className='textSecondTitleViewSettings'>Faça a gestão das Notificações que recebe, associe mais cartões bancários ou desligue a sua Carteira Virtual.</div>
                        </div>
                    </div>
                </div>
                
                <div className={ isTablet ? 'secondMainContainerTwoSettings' : 'secondMainContainerTwoSettingsMobile' }>
                    <button className='mainNavBtnSettings' onClick={hadleBtnClickNotifications}>
                        <div className='mainViewStarSvgSettings'>
                            <img src={ImgSettingsNotifySvg} alt="icon" className={ isTablet ? 'starSvgSettings' : ( isMobile ? 'starSvgSettings' : 'starSvgSettingsMobile' )} />
                        </div>
                        <div className='txtMainRowViewSettings'>
                            <div className='txtNavBtnSettings'>Notificações</div>
                            <div className='arrowIconNavBtnViewSettings'>
                                <FaArrowRightLong className='arrowIconNavBtnSettings' /> 
                            </div>
                        </div>
                    </button>
                    <button className='mainNavBtnSettings' onClick={hadleBtnClickAddCard}>
                        <div className='mainViewStarSvgSettings'>
                            <img src={ImgSettingsAddCardSvg} alt="icon" className={ isTablet ? 'starSvgSettings' : ( isMobile ? 'starSvgSettings' : 'starSvgSettingsMobile' )} />
                        </div>
                        <div className='txtMainRowViewSettings'>
                            <div className='txtNavBtnSettings'>Associar cartões</div>
                            <div className='arrowIconNavBtnViewSettings'>
                                <FaArrowRightLong className='arrowIconNavBtnSettings' /> 
                            </div>
                        </div>
                    </button>
                </div>   
            </div>
            <div id='contactMainContainer' className={ isTablet ? 'secondMainViewContainerSettings' : ( isMobile ? 'secondMainViewContainerSettingsTablet' : 'secondMainViewContainerSettingsMobile' )}>
                <div className='infroMainCardViewSettings'>
                    <div className='contactInfoBoxRowViewSettings'>
                        <div className='emailIconSvgInfoBoxViewSettings'><MdOutlineMail className='emailIconSvgInfoBoxSettings' /></div>
                        <div className='txtRegularInfoBoxSettings'>Email <span className='txtSemiBoldInfoBoxSettings'>Médis Saúde 360</span></div>
                    </div>
                    <div className='contactInfoBoxColumnViewSettings'>
                        <div className='txtEmailRegularInfoBoxSettings'>geral@saude360.medis.pt</div>
                    </div>
                    <div className={ isTablet ? 'btnInfoBoxViewSettings' : 'btnInfoBoxViewSettingsMobile'}>
                        <CustomButton 
                            text={'Enviar email'} 
                            textColor={'#141414'}
                            borderColor={'#141414'}
                            hasShadow={false}
                            hasArrow
                            iconColor={'#141414'}
                            iconType={'email'}
                            onPress={handleSaudeEmailClick}
                        />
                    </div>
                </div>
                <div className='infroMainCardViewSettings'>
                    <div className='contactInfoBoxRowViewSettings'>
                        <div className='emailIconSvgInfoBoxViewSettings'><MdOutlinePhoneInTalk className='emailIconSvgInfoBoxSettings' /></div>
                        <div className='txtRegularInfoBoxSettings'>Telefone <span className='txtSemiBoldInfoBoxSettings'>Médis Saúde 360</span></div>
                    </div>
                    <div className='mainSecondContactInfoBoxColumnViewSettings'>
                        <div className='txtEmailSemiBoldInfoBoxSettings'>210 204 887</div>
                        <div className='contactInfoBoxColumnViewSettings'>
                            <div className='txtEmailRegularInfoBoxSettings'>De segunda a sexta, das 9h às 18h.</div>
                            <div className='txtEmailRegularInfoBoxSettings'>Custo de chamada para rede fixa nacional.</div>
                        </div>
                    </div>
                    <div className={ isTablet ? 'btnInfoBoxViewSettings' : 'btnInfoBoxViewSettingsMobile'}>
                        <CustomButton 
                            text={'Ligar'} 
                            textColor={'#141414'}
                            borderColor={'#141414'}
                            hasShadow={false}
                            hasArrow
                            iconColor={'#141414'}
                            iconType={'phone'}
                            onPress={handleBtnCall}
                        />
                    </div>
                </div>
            </div>
            <div className={ isTablet ? 'thirdMainViewContainerSettings' : ( isMobile ? 'thirdMainViewContainerSettingsTablet' : 'thirdMainViewContainerSettingsMobile' )}>
                <div className='titleMainViewThirdContainerSettings'>
                    <div className='txtTitleThirdContainerSettings'>Apagar carteira virtual</div>
                    <div className='txtThirdContainerSettings'>Pode apagar a sua carteira Médis a qualquer momento.</div>
                </div>
                <div className='btnThirdContainerSettings'>
                    <CustomButton 
                        text={'Apagar Carteira'} 
                        onPress={hadleBtnClickDeleteWallet}
                        textColor={'#00214D'}
                        borderColor={'#00214D'}
                        hasShadow={false}
                    />
                </div>
            </div>
        </div>
        <Footer/> 
        </>
    )
}

export default Settings;